// ©2024 Austin App House. All rights reserved.
import React, { useEffect, useState } from 'react';
import {
  Field, Form, reduxForm,
} from 'redux-form';
import Notification from '../../notification';
import InputField from './customFields/InputField';
import ReactSelectField from './customFields/ReactSelectField';
import { workOrderCustomFieldTypes } from '../../../utils/constans';

const specialCharRegex = /^[a-zA-Z0-9\s-_]+$/;

const validateNoSpecialChars = (value) => {
  if (!value) return undefined;
  return specialCharRegex.test(value)
    ? undefined
    : 'Special characters are not allowed';
};

const requiredField = (value) => (
  value && value.trim() !== '' ? undefined : 'This field is required'
);

let CreateCustomFieldReduxForm = ({
  handleSubmit,
  error,
  disabled,
  initialValues,
  change,
}) => {
  const [customFieldTypeOptions, setCustomFieldTypeOptions] = useState([]);

  useEffect(() => {
    const newCustomFieldTypeOptions = Object.entries(workOrderCustomFieldTypes).map((type) => ({
      value: type[0],
      label: type[1],
    }));
    setCustomFieldTypeOptions(newCustomFieldTypeOptions);
  }, []);

  useEffect(() => {
    if (
      initialValues?.type
      && (typeof initialValues.type === 'string')
    ) {
      change('type', {
        value: initialValues?.type,
        label: workOrderCustomFieldTypes[initialValues?.type],
      });
    }
  }, [initialValues]);

  useEffect(() => {
    if (error) Notification('error', { message: error });
  }, [error]);

  const preventSubmitOnEnter = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault();
    }
  };

  return (
    <Form
      onSubmit={handleSubmit}
      onKeyPress={preventSubmitOnEnter}
    >
      <div className="dashboard-modal-form-fields">
        <div className="field_col">
          <label className="field_name" htmlFor="create-custom-field-name">
            Name
            <span className="requiredField">*</span>
          </label>
          <Field
            id="create-custom-field-name"
            name="name"
            component={InputField}
            type="text"
            placeholder="Custom Field Name"
            inputClassName="dashboard-input"
            paddingBottomClassName=""
            disabled={disabled}
            validate={[requiredField, validateNoSpecialChars]}
          />
        </div>

        <div className="field_col">
          <label className="field_name" htmlFor="create-custom-field-value">
            Value
          </label>
          <Field
            id="create-custom-field-value"
            name="value"
            component={InputField}
            type="text"
            placeholder="Custom Field Value"
            inputClassName="dashboard-input"
            paddingBottomClassName=""
            validate={[validateNoSpecialChars]}
          />
        </div>

        <div className="field_col">
          <label className="field_name" htmlFor="create-custom-field-type">
            Type
            <span className="requiredField">*</span>
          </label>
          <Field
            name="type"
            component={ReactSelectField}
            inputId="create-custom-field-type"
            dashboardStyle
            placeholder="Select Custom Field Type"
            options={customFieldTypeOptions}
            paddingBottomClassName=""
            isSearchable={false}
          />
        </div>
      </div>
    </Form>
  );
};

CreateCustomFieldReduxForm = reduxForm({
  form: 'createCustomFieldReduxForm',
})(CreateCustomFieldReduxForm);

export default CreateCustomFieldReduxForm;
